import { Controller } from "@hotwired/stimulus";

import { showSettings } from "~/lib/cookie-script";
import logger from "~/lib/logger";

const log = logger();

export default class CookieSettingsController extends Controller {
  show(): void {
    if (!showSettings()) {
      log.warn("Cookie consent modal is not available.");
    }
  }
}
